import axios from 'axios';
import { getServerBaseUrl } from './BASE_URL';
import { toast } from 'react-toastify';

export const handleAPIRequest = async (
  method,
  url,
  data = null,
  params = null,
  token = null 
) => {
  const baseURL = getServerBaseUrl();
  const headers = {
    ...(method === 'post' || method === 'put' ? { 'Content-Type': 'multipart/form-data' } : {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };

  try {
    const response = await axios({
      method,
      url: `${baseURL}/${url}`,
      headers,
      data,
      params,
      timeout: 90000,
    });

    return response.data;
  } catch (error) {
    let errorMessage = error.response?.data?.message || 'An error occurred';
    console.error(errorMessage, 'error');

    if (errorMessage === 'Unauthenticated.') {
      errorMessage = 'You are not authorized to perform this action. Kindly login again.';
    }

    if (error.code === 'ECONNABORTED') {
      toast.error("Can't make request");
    } else {
      toast.error(errorMessage);
    }

    throw new Error(errorMessage);
}
};
